/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type AuditLogType = typeof AuditLogType[keyof typeof AuditLogType];


export const AuditLogType = {
  UserCreated: 'UserCreated',
  UserDeleted: 'UserDeleted',
  PermissionAdded: 'PermissionAdded',
  PermissionRevoked: 'PermissionRevoked',
  ActionModuleInstanceCompletey: 'ActionModuleInstanceCompletey',
} as const;
